import { Box, CircularProgress } from '@mui/material';
import { FC } from 'react';

export const FullPageLoading: FC = () => (
  <Box
    sx={{
      display: 'flex',
      height: '100vh',
      width: '100%',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <Box>
      <CircularProgress />
    </Box>
  </Box>
);

export const LoadingWithTopBar: FC = () => <FullPageLoading />;
